import React from 'react';
import { Snackbar, SnackbarContent, IconButton, Box} from '@mui/material';
import { ICross, IError, IInfo, ITick2, IWarning } from './helixIcons';

const variantIcon = {
  success: ITick2,
  warning: IWarning,
  error: IError,
  info: IInfo,
};

interface Props {
  variant: 'error' | 'success' | 'info' | 'warning';
  show: boolean;
  message: string;
  handleClose: () => void;
}

export default function Notification(props: Props) {
  const Icon = variantIcon[props.variant || 'error'] || IError;
  return (
    <Snackbar
      autoHideDuration={props.variant !== 'error' ? 6000 : null}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      onClose={props.handleClose}
      open={props.show}
    >
      <SnackbarContent
        className={props.variant || 'error'}
        message={
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
            <Icon />
            {props.message}
          </Box>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={props.handleClose}
            size="large">
            <ICross />
          </IconButton>,
        ]}
      />
    </Snackbar>
  );
}
